import React from 'react'

import {
    GridContainer,
    GridContainerReport,
    GridItem5,
    GridItem7,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import EstudoFormCapacidadePoupanca from './EstudoFormCapacidadePoupanca'

import EstudoFormNecessidadeAposentadoria from './EstudoFormNecessidadeAposentadoria'

import EstudoFormAportePlanejadoAposentadoria from './EstudoFormAportePlanejadoAposentadoria'



const EstudoFormCapacidadePoupancaNecessidadeAporteAposentadoria = ({ values, estudo, report }) => {

    const CapacidadePoupancaNecessidadeAporteAposentadoria = () => {

        return (
            <GridContainerReport
                className={report ? ''/*'mt--5 ml-2'*/ /* mudança da fonte: mt--10 */ : 'mb-12 ml-4 mt-5' /* mudança da fonte: adicionou mt-5 */}
            >
                <GridItem5>
                    <EstudoFormCapacidadePoupanca
                        values={values}
                        report={report}
                    />
                </GridItem5>

                <GridItem7
                    className='ml--2'
                >
                    <GridContainer>
                        <GridItem12
                            className={report ? 'ml-5' : 'ml-15'}
                        >
                            <EstudoFormNecessidadeAposentadoria
                                values={values}
                                estudo={estudo}
                                report={report}
                            />
                        </GridItem12>

                        <GridItem12
                            className={report ? 'ml-5' : 'ml-15'}
                        >
                            <EstudoFormAportePlanejadoAposentadoria
                                values={values}
                                estudo={estudo}
                                report={report}
                            />
                        </GridItem12>
                    </GridContainer>
                </GridItem7>
            </GridContainerReport>
        )
    }

    return (
       <CapacidadePoupancaNecessidadeAporteAposentadoria/>
    )
}

export default EstudoFormCapacidadePoupancaNecessidadeAporteAposentadoria